import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import { env } from "@/config/env";

if (typeof window !== "undefined") {
  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST,
    person_profiles: "always",
    evaluation_environments: [env.VITE_POSTHOG_ENVIRONMENT],
  });
}

export function CSPostHogProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
